"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGenderPropertyOption = exports.isGenderProperty = exports.genderPropertyDefinition = void 0;
const genderPropertyOptions = ['male', 'female'];
exports.genderPropertyDefinition = {
    view: { label: 'Gender' },
    constraints: [
        {
            name: 'options',
            argument: genderPropertyOptions,
        },
    ],
    type: 'select',
    multiple: false,
    name: 'gender',
};
const isGenderProperty = (prop) => {
    return prop.name === exports.genderPropertyDefinition.name;
};
exports.isGenderProperty = isGenderProperty;
const isGenderPropertyOption = (option) => {
    return genderPropertyOptions.includes(option);
};
exports.isGenderPropertyOption = isGenderPropertyOption;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2VuZGVyLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvZ2VuZGVyLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLE1BQU0scUJBQXFCLEdBQUcsQ0FBQyxNQUFNLEVBQUUsUUFBUSxDQUFVLENBQUE7QUFFNUMsUUFBQSx3QkFBd0IsR0FBRztJQUN0QyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsUUFBUSxFQUFFO0lBQ3pCLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFNBQVM7WUFDZixRQUFRLEVBQUUscUJBQXFCO1NBQ2hDO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsUUFBUTtJQUNkLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLFFBQVE7Q0FDaUIsQ0FBQTtBQUkxQixNQUFNLGdCQUFnQixHQUFHLENBQUMsSUFBa0IsRUFBMEIsRUFBRTtJQUM3RSxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssZ0NBQXdCLENBQUMsSUFBSSxDQUFBO0FBQ3BELENBQUMsQ0FBQTtBQUZZLFFBQUEsZ0JBQWdCLG9CQUU1QjtBQUlNLE1BQU0sc0JBQXNCLEdBQUcsQ0FBQyxNQUFjLEVBQWtDLEVBQUU7SUFDdkYsT0FBUSxxQkFBMkMsQ0FBQyxRQUFRLENBQUMsTUFBTSxDQUFDLENBQUE7QUFDdEUsQ0FBQyxDQUFBO0FBRlksUUFBQSxzQkFBc0IsMEJBRWxDIn0=